export default __webpack_public_path__ + "static/media/icon-question.6c80fb46.svg";